import { render, staticRenderFns } from "./colorMix.vue?vue&type=template&id=b6ad10fa&"
import script from "./colorMix.vue?vue&type=script&lang=js&"
export * from "./colorMix.vue?vue&type=script&lang=js&"
import style0 from "./colorMix.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports